import { AnyType } from '@src/models/common';
import { MouseEvent, useCallback } from 'react';

/**
 *  Хук, который открывает фильтр по нажатию на его бейджик
 * @param dataElemIcon data иконки, при нажатии на которую, не происходит открытие фильтра
 * @param onOpen вызываемый колбек открытия
 * @param name имя фильтра
 */
export const useOpenFilterByName = (
  dataElemIcon: string,
  onOpen: ((arg: AnyType) => void) | undefined,
  name: AnyType,
) => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLDivElement | HTMLAnchorElement>) => {
      if ((e.target as SVGAElement).getAttribute('data-elem') === dataElemIcon) return;

      onOpen?.(name);
    },
    [dataElemIcon, onOpen, name],
  );

  return handleClick;
};
